import { orientationTypes } from '../util';
var alignmentColoring = {
  color_pair_lr: '#c8c8c8',
  color_pair_rr: 'navy',
  color_pair_rl: 'teal',
  color_pair_ll: 'green'
};
export function getInsertSizeColor(f1, f2, stats) {
  var sameRef = f1.refName === f2.refName;
  var tlen = Math.abs(f1.tlen || 0);
  if (sameRef && tlen > ((stats === null || stats === void 0 ? void 0 : stats.upper) || 0)) {
    return 'red';
  } else if (sameRef && tlen < ((stats === null || stats === void 0 ? void 0 : stats.lower) || 0)) {
    return '#f0f';
  } else if (!sameRef) {
    return 'purple';
  }
  return '';
}
export function getInsertSizeAndOrientationColor(f1, f2, stats) {
  return getInsertSizeColor(f1, f2, stats) || getOrientationColor(f1);
}
export function getOrientationColor(f) {
  var type = orientationTypes['fr'];
  var orientation = type[f.pair_orientation || ''];
  var map = {
    LR: 'color_pair_lr',
    RR: 'color_pair_rr',
    RL: 'color_pair_rl',
    LL: 'color_pair_ll'
  };
  var val = map[orientation];
  return alignmentColoring[val] || 'grey';
}